import isClient from "./isClient";

export default function isMobile() {
  if (!isClient()) return
  return !!window.matchMedia("screen and (max-width:767px)").matches
}
